import React, { createContext, useState, useContext } from "react";

const GlobalContext = createContext();

export const useGlobalContext = () => {
  const context = React.useContext(GlobalContext);
  if (context === undefined) {
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  }
  return context;
};

export const GlobalProvider = ({ children }) => {
  const [globalState, setGlobalState] = useState({
    customeGlobalClasse: [],
  });

  const value = [globalState, setGlobalState];

  return (
    <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
  );
};
